import React from 'react';

import { Box } from '@mui/material';

import { CommonComponentProps } from '../pages/types';

const Divider: React.FC<CommonComponentProps> = ({ id, sx }) => {
  return (
    <Box
      id={id}
      sx={{
        width: '100%',
        height: '100%',
        minHeight: 1,
        bgcolor: (sx as any)?.background || 'divider',
      }}
    />
  );
};

export default Divider;
